module.exports = __webpack_public_path__ + "static/media/Home_page_bg02.fd6edd15.png";